"use client";

import SingleSwiper from "@/swiper/SingleSwiper";
import { EPageName } from "@/util/enum";
import PackageCard, { type PackageCardProps } from "./PackageCard";

export type PackageCardSwiperProps = {
  items: PackageCardProps[];
};

const PackageCardSwiper = ({ items }: PackageCardSwiperProps) => (
  <SingleSwiper
    pageName={EPageName.PACKAGESLIDE}
    crouselData={items}
    slideDelayTime={2500}
    autoHeight={false}
    loop={true}
    slideClassName="h-auto! self-stretch pt-4"
    renderItem={(item: PackageCardProps, index: number) => (
      <PackageCard
        key={`${item.name ?? "package"}-${index}`}
        {...item}
        index={index}
      />
    )}
  />
);

export default PackageCardSwiper;
